export default "__VITE_ASSET__ByIqLSpx__"